import {
  SmallGoodsItem,
  SmallGoodsItemProps,
} from "./components/SmallGoodsItem";
import { FillGoodsItem, FillGoodsItemProps } from "./components/FillGoodsItem";
import {
  FillGoodsItemWithBuy,
  FillGoodsItemWithBuyProps,
} from "./components/FillGoodsItemWithBuy";
import {
  SmallGoodsItemWithBuy,
  SmallGoodsItemWithBuyProps,
} from "./components/SmallGoodsItemWithBuy";
import {
  SingleRowGoodsItemWithBuy,
  SingleRowGoodsItemWithBuyProps,
} from "./components/SingleRowGoodsItemWithBuy";
import { ComponentType } from "react";

/**
 * 处理商品描述中的换行符，统一转换为标准格式并分割成行数组
 * 支持处理：转义的 \n、Windows \r\n、老macOS \r、Unix \n
 * @param desc - 商品描述文本
 * @returns 处理后的行数组，已过滤空行
 */
export const processDescText = (desc: string | undefined): string[] => {
  if (!desc) return [];
  
  // 处理各种换行符格式：转义的 \n、Windows \r\n、老macOS \r、Unix \n
  const normalizedText = desc
    .replace(/\\n/g, '\n')  // 处理转义的 \n
    .replace(/\\r/g, '\r')  // 处理转义的 \r
    .replace(/\r\n/g, '\n')   // Windows 换行符
    .replace(/\r/g, '\n');   // 老 macOS 换行符
  
  // 分割成行并过滤空行
  return normalizedText.split('\n').filter(line => line.trim() !== '');
};

export const formatCountdown = (milliseconds) => {
  const totalSeconds = Math.floor(milliseconds / 1000);
  const days = Math.floor(totalSeconds / 86400) + 1;
  const hours = String(Math.floor((totalSeconds % 86400) / 3600)).padStart(
    2,
    "0",
  );
  const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(
    2,
    "0",
  );
  const seconds = String(totalSeconds % 60).padStart(2, "0");
  return days > 1 ? `${days}天` : ` ${hours}:${minutes}:${seconds}`;
};

export const renderTypeMapEnums = {
  SMALL_GOODS: SmallGoodsItem as ComponentType<SmallGoodsItemProps>,
  HALF_ROW_GOODS: SmallGoodsItem as ComponentType<SmallGoodsItemProps>,
  FILL_ROW_GOODS: FillGoodsItem as ComponentType<FillGoodsItemProps>,
  FILL_ROW_GOODS_BUY:
    FillGoodsItemWithBuy as ComponentType<FillGoodsItemWithBuyProps>,
  SMALL_ROW_GOODS_BUY:
    SmallGoodsItemWithBuy as ComponentType<SmallGoodsItemWithBuyProps>,
  SINGLE_ROW_GOODS_BUY:
    SingleRowGoodsItemWithBuy as ComponentType<SingleRowGoodsItemWithBuyProps>,
};
